import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const FullScreenLoader: React.FC<{ text?: string }>= ({ text }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
        backdropFilter: 'blur(10px)',
        background:
          'radial-gradient(1200px 600px at 0% -10%, rgba(14,165,233,0.12), rgba(255,255,255,0.18)), radial-gradient(1000px 600px at 100% -20%, rgba(147,197,253,0.12), rgba(255,255,255,0.18))',
      }}
    >
      <Box
        component="span"
        sx={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          display: 'inline-block',
          borderTop: '3px solid #FFF',
          borderRight: '3px solid transparent',
          boxSizing: 'border-box',
          animation: 'rotation 1s linear infinite',
          '@keyframes rotation': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' },
          },
          filter: 'drop-shadow(0 6px 18px rgba(2,132,199,0.35))',
        }}
      />
      {text !== undefined ? (
        <Typography variant="subtitle1" sx={{ mt: 1, color: theme.palette.secondary.dark, fontWeight: 700 }}>
          {text}
        </Typography>
      ) : null}
    </Box>
  );
};

export default FullScreenLoader;
